let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("auOeG")).then(() => parcelRequire('1Z7Vf'));